import type { JsonSchemaViewer as JsonSchemaViewerType } from '@tarslib/json-schema-viewer';
import { JsonSchemaViewer as JsonSchemaViewerComponent } from '@tarslib/json-schema-viewer/dist/index.js';
import '@tarslib/json-schema-viewer/dist/index.css';

export function JsonSchemaViewer(props: Parameters<typeof JsonSchemaViewerType>[0]) {
  return <JsonSchemaViewerComponent {...props} />;
}
